// extracted by mini-css-extract-plugin
export default {"tapeBody":"light_tapeBody__WbuKv color_colorLightBorder__6Pa4H","overflow":"light_overflow__U7xLK color_colorLightBackground__vzlHN"};